// ContactInformation.js
import React from 'react';
import { motion } from 'framer-motion';
import { Mail, Phone, Clock, MapPin } from 'lucide-react';

const ContactInformation = () => {
  const contactInfo = [
    {
      icon: Mail,
      title: 'Email',
      content: 'info@notapaths.com',
      link: 'mailto:info@notapaths.com',
      color: 'blue'
    },
    {
      icon: Phone,
      title: 'Phone',
      content: ['+44 07418 622985'],
      color: 'green'
    },
    {
      icon: Clock,
      title: 'Business Hours',
      content: ['Monday to Friday', '9:00 AM to 6:00 PM (London Time)'],
      color: 'orange'
    },
    {
      icon: MapPin,
      title: 'Office Location',
      content: ['8a Hessel Street, Ground Floor', 'London, United Kingdom, E1 2LP'],
      color: 'purple'
    }
  ];

  const getColorClasses = (color) => {
    const colors = {
      blue: 'border-t-blue-500',
      green: 'border-t-green-500',
      orange: 'border-t-orange-500',
      purple: 'border-t-purple-500'
    };
    return colors[color] || 'border-t-blue-500';
  };

  return (
    <section className="py-16 bg-white">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        {/* Section Header */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-12"
        >
          <h2 className="text-3xl md:text-4xl font-semibold text-[#202356] mb-4">
            Contact Information
          </h2>
          <p className="text-gray-600 text-sm font-light">
            Notapaths
          </p>
        </motion.div>

        {/* Contact Cards Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
          {contactInfo.map((info, index) => {
            const Icon = info.icon;
            return (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.6, delay: index * 0.1 }}
                className={`bg-white p-6 border-t-2 ${getColorClasses(info.color)} hover:shadow-lg transition-shadow`}
              >
                <Icon size={32} className="text-gray-700 mb-4" />
                
                <h3 className="text-lg font-semibold text-[#202356] mb-3 leading-tight">
                  {info.title}
                </h3>
                
                <div className="text-gray-600 text-sm font-light leading-relaxed">
                  {info.link ? (
                    <a 
                      href={info.link}
                      className="hover:text-[#2542D4] transition-colors"
                    >
                      {info.content}
                    </a>
                  ) : Array.isArray(info.content) ? (
                    info.content.map((line, i) => (
                      <p key={i}>{line}</p>
                    ))
                  ) : (
                    <p>{info.content}</p>
                  )}
                </div>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default ContactInformation;
